import { render, staticRenderFns } from "./RetornoCampo.vue?vue&type=template&id=996b841e&scoped=true&"
import script from "./RetornoCampo.vue?vue&type=script&lang=js&"
export * from "./RetornoCampo.vue?vue&type=script&lang=js&"
import style0 from "./RetornoCampo.vue?vue&type=style&index=0&id=996b841e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996b841e",
  null
  
)

export default component.exports